import ButtonKaraoke from '@/context/domain/g02/g02-d03/g02-d03-p001-karaoke/components/ButtonKaraoke';
import IconArrowLeft from '@/context/global/components/Icon/IconArrowLeft';
import IconMusicFilter from '@/context/global/components/Icon/IconMusicFilterr';
import IconSearch from '@/context/global/components/Icon/IconSearch';
import { cn } from '@/context/global/utils/cn';

type HeaderKaraokeProps = {
  className?: string;
  isOpen: boolean;
  isPreview?: boolean;

  onSearch?: () => void;
  onBack?: () => void;
  onSidebarClick?: () => void;
};

const HeaderKaraoke = ({
  className,
  isOpen,
  isPreview,
  onBack,
  onSearch,
  onSidebarClick,
}: HeaderKaraokeProps) => {
  return (
    <div
      className={cn(
        'flex items-center justify-end p-4 px-6 md:justify-between',
        className,
      )}
    >
      {/* Back Button */}
      <ButtonKaraoke
        onClick={onBack}
        className="hidden h-12 w-12 items-center justify-center rounded-full border border-white/20 bg-black/40 text-white transition-colors hover:bg-black/60 md:flex"
        aria-label="Go back"
      >
        <IconArrowLeft />
      </ButtonKaraoke>

      {/* Logo and Right Controls */}
      <div hidden={isOpen || isPreview} className="hidden items-center gap-4 md:flex">
        {/* Logo */}

        {/* Search Icon */}
        <ButtonKaraoke
          onClick={onSearch}
          className="transform transition-all hover:scale-110"
          aria-label="Search"
        >
          <IconSearch />
        </ButtonKaraoke>

        {/* List Button */}
        <ButtonKaraoke
          onClick={onSidebarClick}
          className="transform transition-all hover:scale-110"
          aria-label="Song List"
        >
          <IconMusicFilter />
        </ButtonKaraoke>
      </div>
    </div>
  );
};

export default HeaderKaraoke;
